var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPoint2X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 2",
    d: "M20.623 0a1 1 0 0 1 .582.187l7.474 5.352a1 1 0 0 1 .367.5l2.85 8.648a1 1 0 0 1 0 .626l-2.85 8.648a1 1 0 0 1-.367.5l-7.474 5.352a1 1 0 0 1-.582.187h-9.246a1 1 0 0 1-.582-.187l-7.474-5.352a1 1 0 0 1-.367-.5L.1 15.313a1 1 0 0 1 0-.626l2.85-8.648a1 1 0 0 1 .367-.5L10.795.187A1 1 0 0 1 11.377 0z",
    style: {
      fill: "#e8a101"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(10 21)",
    style: {
      fill: "#fff4f4",
      fontSize: 18,
      fontFamily: "NunitoSans-Bold,Nunito Sans",
      fontWeight: 700
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoint2X);
export default __webpack_public_path__ + "static/media/icon-point@2x.25e91f6f.svg";
export { ForwardRef as ReactComponent };